import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getProspectReference } from "@utils/storage";
import { IEirSalesAddonPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesAddonPayload";
import { deleteAddonRoute, postAddonRoute } from "@api-routes/eirSalesFacade";
import { getResponseToState } from "@mappers/getCartMapper";
import { ICart } from "@features/cart/ICart";

export const postAddon = (offerId: number, payload: IEirSalesAddonPayload, options: IFetchOptions = {}) => {
    const prospectReference = getProspectReference();

    return fetcher<ICart>(postAddonRoute(prospectReference, offerId), {
        ...options,
        method: "POST",
        body: payload,
        mapper: getResponseToState,
    });
};

export const deleteAddon = (offerId: number, addonId: number, options: IFetchOptions = {}) => {
    const prospectReference = getProspectReference();

    return fetcher<ICart>(deleteAddonRoute(prospectReference, offerId, addonId), {
        ...options,
        method: "DELETE",
        mapper: getResponseToState,
    });
};
